import React from 'react';
import Dialog from '@mui/material/Dialog';
import DialogTitle from '@mui/material/DialogTitle';
import DialogContent from '@mui/material/DialogContent';
import DialogActions from '@mui/material/DialogActions';
import Button from '@mui/material/Button';
import Typography from '@mui/material/Typography';
import Box from '@mui/material/Box';
import { AlertCircle } from 'lucide-react';

const DeleteConfirmation = ({
  open,
  onClose,
  onConfirm,
  title = "Confirmer la suppression",
  message,
  itemName
}) => {
  return (
    <Dialog
      open={open}
      onClose={onClose}
      maxWidth="xs"
      fullWidth
      PaperProps={{
        sx: {
          borderRadius: '12px',
          padding: '16px'
        }
      }}
    >
      <Box sx={{ textAlign: 'center', pt: 2 }}>
        <AlertCircle size={50} color="#d32f2f" />
      </Box>

      <DialogTitle sx={{ textAlign: 'center' }}>
        {title}
      </DialogTitle>

      <DialogContent>
        <Typography variant="body1" color="text.secondary" align="center" gutterBottom>
          {message || `Êtes-vous sûr de vouloir supprimer ${itemName} ?`}
        </Typography>
        <Typography variant="body2" color="text.secondary" align="center">
          Cette action est irréversible.
        </Typography>
      </DialogContent>

      <DialogActions sx={{ justifyContent: 'center', pb: 3, gap: 1 }}>
        <Button
          onClick={onClose}
          variant="outlined"
          sx={{
            borderRadius: '8px',
            textTransform: 'none',
            px: 3
          }}
        >
          Annuler
        </Button>
        <Button
          onClick={onConfirm}
          variant="contained"
          color="error"
          sx={{
            borderRadius: '8px',
            textTransform: 'none',
            px: 3
          }}
        >
          Supprimer
        </Button>
      </DialogActions>
    </Dialog>
  );
};

export default DeleteConfirmation;